import React, { useState } from 'react'

import {
  Button,
  ButtonGroup,
  Checkbox,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Stack,
  Text,
} from '@chakra-ui/react'

const ConstituentExportLanguage = ({ isOpen, onClose, onConfirm }) => {
  const [accepted, setAccepted] = useState(false)
  const handleCancel = () => {
    setAccepted(false)
    onClose()
  }
  return (
    <Modal isOpen={isOpen} onClose={handleCancel} isCentered={true} size='2xl'>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalHeader>Exporting Constituents</ModalHeader>
        <ModalBody>
          <Stack>
            <Text>
              Please be advised by accessing and downloading data from Council
              Connect which contains or may contain Personally Identifying
              Information (PII) you are confirming that you are doing so in
              furtherance of you work as an official or employee of the New York
              City Council (“Council”) any other use is strictly prohibited.
            </Text>
            <Text>
              This data may only be downloaded and stored on the Council's
              network and /or a New York City Council issued device(s). All
              reasonable precautions, must be taken to safeguard the respective
              data and prevent unauthorized access or disclosure.
            </Text>
            <Text>
              Adherence to the Council's Privacy Protection Guidelines issued by
              the Office of the General Council is required. Lack of adherence
              to this policy my result in disciplinary action and/ or
              termination of employment.
            </Text>
            <Text>
              Please reach out to the Office of the General Counsel regarding
              any question or concerns related to PII or the Council's Privacy
              Protection Guidelines.
            </Text>

            <Checkbox
              isChecked={accepted}
              onChange={e => setAccepted(e.target.checked)}
              colorScheme='green'
              size='md'
              fontWeight='bold'
              mt={4}
            >
              I confirm that I have read and understand the above, and I am
              authorized to download data from Council Connect
            </Checkbox>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Flex w='full' as={ButtonGroup} size='md'>
            <Button variant='ghost' onClick={handleCancel} colorScheme='gray'>
              Cancel
            </Button>
            <Spacer />
            <Button
              disabled={!accepted}
              onClick={onConfirm}
              colorScheme='green'
            >
              Confirm
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ConstituentExportLanguage
